import React, { Component } from 'react';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import './ConsultaDNI.css';

class ConsultaDNI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dni: '',
      estado: '',
      comercio: localStorage.getItem('comercioNombre') || '',
      isReadyForInstall: false,
    };
  }

  componentDidMount() {
    window.addEventListener("beforeinstallprompt", (event) => {
      // Prevent the mini-infobar from appearing on mobile.
      event.preventDefault();
      console.log("👍", "beforeinstallprompt", event);
      // Stash the event so it can be triggered later.
      window.deferredPrompt = event;
      // Remove the 'hidden' class from the install button container.
      this.setState({ isReadyForInstall: true });
    });

    if (!this.state.comercio) {
      this.pedirNombreComercio();
    }
  }

  // Pide el nombre del comercio una sola vez (no es un login, solo identifica quién consulta)
  pedirNombreComercio = () => {
    Swal.fire({
      title: 'Nombre del comercio',
      text: 'Ingresá el nombre de tu comercio para identificar las consultas que realizás.',
      input: 'text',
      inputPlaceholder: 'Ej: Farmacia Central',
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'Guardar',
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return 'Ingresá el nombre del comercio para continuar';
        }
      },
    }).then((result) => {
      const nombre = result.value.trim();
      localStorage.setItem('comercioNombre', nombre);
      this.setState({ comercio: nombre });
    });
  };

  handleChange = (e) => {
    this.setState({ dni: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    // Establece la URL de la API PHP: en localhost usa el backend local para pruebas,
    // en el sitio publicado usa el endpoint real del servidor.
    const apiUrl = window.location.hostname === 'localhost'
      ? "http://localhost:8080/api.php"
      : "https://am.asijemin.org.ar/backend/api.php";

    const dniRegex = /^\d{8}$/;
    if (!dniRegex.test(this.state.dni)) {
      // Mostrar SweetAlert con mensaje de error
      Swal.fire({
        title: "Error!",
        text: "El DNI ingresado no tiene el formato correcto (debe ser un número de 8 dígitos).",
        icon: "error"
      });
      return; // Detener la ejecución si el DNI no tiene el formato correcto
    }

    // Realiza la solicitud a la API PHP
    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: `dni=${encodeURIComponent(this.state.dni)}&comercio=${encodeURIComponent(this.state.comercio)}`,
    })
      .then((response) => response.json())
      .then((data) => {
        if (this.state.dni === '') {
          // DNI está vacío
          Swal.fire({
            title: 'Error',
            text: 'No hay ningún carácter',
            icon: 'error',
            confirmButtonText: 'Entendido',
          });
        } else if (!/^[0-9]+$/.test(this.state.dni)) {
          // DNI contiene letras o caracteres no numéricos
          Swal.fire({
            title: 'Atencion',
            text: 'Solo son válidos números, no se permiten letras ni puntos',
            icon: 'warning',
            confirmButtonText: 'Entendido',
          });
        } else if (data.message === "No se encontró ningún afiliado con el DNI proporcionado.") {
          // No se encontró ningún afiliado con el DNI proporcionado
          Swal.fire({
            title: 'Error',
            text: 'No se encontró ningún afiliado con el DNI proporcionado',
            icon: 'error',
            confirmButtonText: 'Entendido',
          });
        } else {
          // Respuesta exitosa
          let title, text, icon, confirmButtonText;

          if (data.estado === 'Expulsado') {
            title = 'Afiliado Expulsado';
            text = 'El afiliado no puede recibir ningún beneficio.';
            icon = 'error';
            confirmButtonText = 'Cerrar';
          } else if (data.autorizado) {
            title = 'Afiliado Autorizado';
            text = 'El afiliado puede recibir beneficios.';
            icon = 'success';
            confirmButtonText = 'Aceptar';
          } else {
            title = 'Afiliado de Baja';
            text = 'El afiliado no puede recibir beneficios (verifique el estado y el aporte).';
            icon = 'error';
            confirmButtonText = 'Cerrar';
          }

          const familiares = data.autorizado ? (data.familiares || []) : [];

          const escapeHtml = (str) =>
            String(str).replace(/[&<>"']/g, (c) => ({
              '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
            }[c]));

          const familiaresHtml = familiares.length > 0
            ? `
              <p class="mt-1 mb-2 text-sm font-semibold text-slate-700 text-left">Familiares autorizados</p>
              <table class="w-full text-sm text-left rounded-lg overflow-hidden border border-slate-200">
                <thead>
                  <tr class="bg-emerald-50 text-emerald-700">
                    <th class="px-3 py-2 font-medium">Nombre</th>
                    <th class="px-3 py-2 font-medium">Parentesco</th>
                  </tr>
                </thead>
                <tbody>
                  ${familiares
                    .map(
                      (f) => `
                        <tr class="odd:bg-white even:bg-slate-50 border-t border-slate-100">
                          <td class="px-3 py-2 text-slate-700">${escapeHtml(f.nombre)}</td>
                          <td class="px-3 py-2 text-slate-500">${escapeHtml(f.parentesco)}</td>
                        </tr>
                      `
                    )
                    .join('')}
                </tbody>
              </table>
            `
            : '';

          this.setState({ estado: data.estado });

          Swal.fire({
            title,
            html: `<p class="text-slate-600">${text}</p>${familiaresHtml}`,
            icon,
            confirmButtonText,
            width: familiares.length > 0 ? 420 : undefined,
          }).then(() => {
            this.setState({ estado: '' });
          });
        }

        // Borra el contenido del campo DNI después de la consulta exitosa o de un error
        this.setState({ dni: '' });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  downloadApp = async () => {
    console.log("👍", "butInstall-clicked");
    const promptEvent = window.deferredPrompt;
    if (!promptEvent) {
      // The deferred prompt isn't available.
      console.log("oops, no prompt event guardado en window");
      return;
    }
    // Show the install prompt.
    promptEvent.prompt();
    // Log the result
    const result = await promptEvent.userChoice;
    console.log("👍", "userChoice", result);
    // Reset the deferred prompt variable, since
    // prompt() can only be called once.
    window.deferredPrompt = null;
    // Hide the install button.
    this.setState({ isReadyForInstall: false });
  };

  render() {
    const backgroundImage = "https://i.pinimg.com/originals/9c/fd/56/9cfd56bf88a7ed515d5d239454c70703.png";

    return (
      <div className="min-h-screen md:flex bg-slate-50">
        {/* Panel de imagen: visible como fondo completo en mobile, columna fija en desktop */}
        <div className="hidden md:block md:w-1/2 relative">
          <img src={backgroundImage} alt="Trabajadores mineros de Asijemin" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/10 to-transparent" />
        </div>

        <div className="relative md:w-1/2 min-h-screen flex items-center justify-center px-4 py-12">
          <img src={backgroundImage} alt="" aria-hidden="true" className="md:hidden absolute inset-0 w-full h-full object-cover" />
          <div className="md:hidden absolute inset-0 bg-slate-900/50" />

          <div className="relative w-full max-w-sm bg-white shadow-xl rounded-2xl px-6 sm:px-8 py-10 text-center">
            <img src="/asijeminlogo.png" alt="Logo Asijemin" className="w-36 sm:w-40 mx-auto mb-6" />

            <h1 className="text-2xl font-semibold text-slate-800 mb-1">
              Consulta de Estado de Afiliado
            </h1>
            <p className="text-sm text-slate-500 mb-6">
              Verificá si el afiliado y su grupo familiar están habilitados para recibir el beneficio.
            </p>

            <form onSubmit={this.handleSubmit} className="text-left">
              <label className="block text-sm font-medium text-slate-600">
                DNI del afiliado
                <input
                  className="mt-2 w-full border border-slate-300 rounded-xl px-4 py-3 text-center text-lg tracking-wide focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition"
                  type="text"
                  inputMode="numeric"
                  placeholder="Ej: 30123456"
                  value={this.state.dni}
                  onChange={this.handleChange}
                />
              </label>

              <button
                type="submit"
                className="mt-4 w-full bg-emerald-600 hover:bg-emerald-700 text-white font-medium py-3 rounded-xl transition shadow-sm"
              >
                Consultar
              </button>
            </form>

            {this.state.isReadyForInstall && (
              <button
                onClick={this.downloadApp}
                className="mt-4 w-full bg-orange-500 hover:bg-orange-600 text-white font-medium py-3 rounded-xl transition shadow-sm"
              >
                Descargar la Aplicación
              </button>
            )}

            {this.state.estado && (
              <p className="mt-6 text-sm text-slate-500">
                Estado del afiliado: <span className="font-medium text-slate-700">{this.state.estado}</span>
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default ConsultaDNI;
